import AsyncSelect from 'react-select/async';
import { components } from 'react-select';
import { getRandomUid } from 'utilities/uuid.service';
import { useMemo, useState } from 'react';
import { contentErrors } from 'utilities/constants';

const InputOption = ({
  getStyles,
  Icon,
  isDisabled,
  isFocused,
  isSelected,
  children,
  innerProps,
  ...rest
}) => {
  const [isActive, setIsActive] = useState(false);
  const onMouseDown = () => setIsActive(true);
  const onMouseUp = () => setIsActive(false);
  const onMouseLeave = () => setIsActive(false);

  // styles
  let bg = 'transparent';
  if (isFocused) bg = '#eee';
  if (isActive) bg = '#B2D4FF';

  const style = {
    alignItems: 'center',
    backgroundColor: bg,
    color: 'inherit',
    display: 'flex ',
  };

  // prop assignment
  const props = {
    ...innerProps,
    onMouseDown,
    onMouseUp,
    onMouseLeave,
    style,
  };

  return (
    <components.Option
      {...rest}
      isDisabled={isDisabled}
      isFocused={isFocused}
      isSelected={isSelected}
      getStyles={getStyles}
      innerProps={props}
    >
      <input type="checkbox" checked={isSelected} style={{ marginRight: '10px' }} />
      {children}
    </components.Option>
  );
};

function PickIssuesList({ isMulti, values, handleChange }) {
  const _id = getRandomUid();

  const defaultOptions = useMemo(() => {
    const array = [];
    for (const [key, value] of Object.entries(contentErrors)) {
      array.push({ label: value, value: key });
    }
    return array;
  }, []);

  return (
    <>
      <label htmlFor={_id}>Select Genre* :</label>
      <div className="position-relative">
        <AsyncSelect
          placeholder={`Choose single or multiple genres`}
          inputId={_id}
          isMulti={isMulti}
          closeMenuOnSelect={false}
          hideSelectedOptions={false}
          cacheOptions
          onChange={handleChange}
          defaultOptions={defaultOptions}
          value={values}
          className="issue-list-popiulate"
          classNamePrefix={`issue-list`}
          components={{
            Option: InputOption,
          }}
        />
      </div>
    </>
  );
}

PickIssuesList.defaultProps = {
  values: [],
  isMulti: true,
  handleChange: () => {},
};

export default PickIssuesList;
